// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_nMi","colMin":"styles_colMin__1zuNc"};